import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const TabsContainer = styled.div`
  display: flex;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
`

export const TabButton = styled.button<{ $isActive: boolean }>`
  flex: 1;
  min-width: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  ${({ $isActive }) =>
    $isActive &&
    css`
      /* Expand over the container border so the active border replaces it. */
      margin: -1px;
      height: 42px;
      background-color: ${COLORS.primaryLight};
      border-color: ${COLORS.primaryDark};
    `}
`
